module.exports = __webpack_public_path__ + "img/left_img1.9d095044.png";